/*Handles state transitions associated with free text survey actions dispatched */

import produce from 'immer';
import * as actions from '../actions/actionTypes';

const freeTextSurvey = (state = initFreeTextSurveyStore(), action) =>
    produce(state, draft => {
        switch (action.type) {
            case actions.FREE_TEXT_BUILD_QUESTIONNAIRE:
                draft.question = action.question;
                draft.freeTextQuestionnaireRetrieved = true;
                draft.displayFreeTextSurveyAlert = false;
                break;
            case actions.FREE_TEXT_DISCARD_ANSWER:
                draft.question.answer = '';
                break;
            case actions.FREE_TEXT_UPDATE_ANSWER:
                draft.question.answer = action.answer;
                break;
            case actions.FREE_TEXT_TOGGLE_ALERT:
                draft.displayFreeTextSurveyAlert = !draft.displayFreeTextSurveyAlert;
                break;
            case actions.FREE_TEXT_DISCARD_ENTIRE_QUESTIONNAIRE:
                draft.question = {
                    linkId: '',
                    title: '',
                    text: '',
                    answer: '',
                };
                draft.freeTextQuestionnaireRetrieved = false;
                draft.displayFreeTextSurveyAlert = false;
                break;
            default:
        }
    });

export const initFreeTextSurveyStore = () => {
    return {
        question: {
            linkId: '',
            title: '',
            text: '',
            answer: '',
        },
        freeTextQuestionnaireRetrieved: false,
        displayFreeTextSurveyAlert: false,
    };
};

export default freeTextSurvey;
